<template>
  <div class="container-block" style="margin: 15px 0">
    <a-tabs default-active-key="1" @change="tabChange">
      <a-tab-pane tab="配方原料" key="1">
        <a-table 
          :columns="columns" 
          :data-source="list.records"
          :row-key="record => record.id"
          :scroll="{ x:0, y: 300 }"
          :pagination="false"
          :loading='tabLoading'
        >
          <template slot="rawName" slot-scope="text,record">
            {{overseasFlag == '1' ? (record.aliasName || text) : text}}
          </template>
          <template
            v-for="uasge in ['uasge','percentage','minValue','maxValue']"
            :slot="uasge"
            slot-scope="text"
          >
          {{text|numberFixed(3)}}
          </template>
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="配方营养需要量" key="2">
        <a-table 
          :columns="columns1"
          :data-source="list.records"
          :row-key="record => record.id"
          :scroll="{ x:0, y: 300 }"
          :pagination="false"
          :loading="tabLoading"
        >
          <template
            v-for="uasge in ['content','minValue','maxValue']"
            :slot="uasge"
            slot-scope="text,record"
          >
          {{text|numberFixed(record.unit ==='MJ' || record.unit ==='Kcal' ? 0 : 2)}}
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>


<script>
import {nhfMixins} from '../../untils'
import { getRequest } from "@/components/Common/Utils/Utils.js";
export default {
  mixins:[nhfMixins],
  data(){
    return {
      current: 1,
      formulaId: getRequest('id'),
      list:[],
      showPagination:false,
      tabLoading: false,
      columns:[
        {
          dataIndex:'rawName',
          title: '原料名称',
          width: 200,
          scopedSlots: {customRender: 'rawName'},
        },
        {
          dataIndex:'rawCode',
          title: '代码',
          width: 100
        },
        {
          dataIndex:'percentage',
          scopedSlots: {customRender: 'percentage'},
          title: '用量(%)',
          width: 80
        },
        {
          dataIndex:'uasge',
          scopedSlots: {customRender: 'uasge'},
          title: '用量(批次量)'
        },
        {
          dataIndex:'unit',
          title: '单位',
          width: 80
          // align:'center'
        },
        {
          dataIndex:'minValue',
          title: '最小值',
          scopedSlots: {customRender: 'minValue'},
        },
        {
          dataIndex:'maxValue',
          title: '最大值',
          scopedSlots: {customRender: 'maxValue'},
        }
      ],
      columns1:[
        {
          dataIndex:'nutritionName',
          title:'指标名称'
        },
        {
          dataIndex:'nutritionFullName',
          title:'指标全称',
          // width:280
        },
        // {
        //   dataIndex:'nutritionCode',
        //   title:'指标代码'
        // },
        {
          dataIndex:'content',
          scopedSlots: {customRender: 'content'},
          title:'数值',
        },
        {
          dataIndex:'unit',
          title:'单位',
          // align:'center'
        },
        {
          dataIndex:'minValue',
          scopedSlots: {customRender: 'minValue'},
          title:'最小值'
        },
        {
          dataIndex:'maxValue',
          scopedSlots: {customRender: 'maxValue'},
          title:'最大值',
        }
      ],
      overseasFlag: window.localStorage.getItem('overseasFlag')
    }
  },
  mounted(){
    this.getList({formulaId:this.formulaId})
  },
  methods: {
    tabChange(current){
      this.list.records = []
      this.current = current
      this.getList()
    },
    getList(arg = {}) {
      this.loading = true
      this.$nextTick(() => {
        if(!this.formulaId) return
        const actions = this.current == 1 ? this.formulaRawNhfPage : this.formulaNutritionNhfPage
        this.fetchGet({
          actions,
          loading: 'tabLoading',
          showMessage: false,
          data:{
            formulaId:this.formulaId,
            factoryId:this.factoryId,
            ...arg,
            size:1000,
          },
          name:'list',
          isList:true
        })
      })
    },
  }
}
</script>